
import React from 'react';
import { DivGrid } from "../../../client/components/div-grid";
import {DEVICE_WIDTH} from "../../constants";

const render_recurring_payment = (
  component, yes_no_checkbox, contribute_amt, contribute_cadence) => {

  const checkbox_style = {
    marginTop: "0.25rem"
  };
  const contrib_style = {
    width: "100%",
    textAlign: "center",
  };

  const div_style = {
      paddingRight: "2rem",

      marginBottom: "1rem",
  }

  const show_contrib = yes_no_checkbox.isItemClicked(0, component.state);
  const row = [
    {
      width: 0,
      elem: (
        <div>
          { yes_no_checkbox.renderRadioLabel(0, component, checkbox_style) }
          { yes_no_checkbox.renderRadioLabel(1, component, checkbox_style) }
        </div>
      ),
      div_style: {...div_style, paddingTop: "1rem"},
    },
    {
      width: 0,
      elem: show_contrib
        ? (
          <div>
            <div>{contribute_cadence.name.label}</div>
            { contribute_cadence.renderMenu(component) }
          </div>
        ) : null,
        div_style: div_style,
    },
    {
      width: 0,
      elem: show_contrib ? (
        <div>
          <div>{contribute_amt.name.label}</div>
          { contribute_amt.renderInput(component, contrib_style) }
        </div>
      ) : null,
      div_style: {...div_style, padding: "0"},
    }
  ];

  return (
    <DivGrid items={[row]}/>
  )
};

const render_recurring_payment_2 = (
  component, yes_no_checkbox, contribute_amt, contribute_cadence, width) => {

  const contrib_style = {
    width: "100%",
    textAlign: "center",
  };

  const cadence_raw = contribute_cadence.getValue(component.state);
  const is_monthly = cadence_raw && cadence_raw.id === "MONTHLY";
  //const dom = component.state.jan_date.day.toString();
  /*const show_cal_cb = () => {
    component.setState({ show_calendar: !component.state.show_calendar } );
  };
  const popup_style = {
    width: "20rem",
  }
  const date = new Date(
    component.state.jan_date.year,
    component.state.jan_date.month - 1,
    component.state.jan_date.day);
  const date_from = new Date(
    component.state.jan_date.year, 0, 1);
  const date_to = new Date(
    component.state.jan_date.year, 0, 31);

  const on_click = value => {
    const new_state = {
      show_calendar: false,
      jan_date: deep_copy(component.state.jan_date),
      dirty: true,
    };
    new_state.jan_date.day = value.getDate();
    component.setState(new_state);
  }

  const popup = component.state.show_calendar
    ?
    (<Popup style={popup_style}>
      <Calendar
        activeStartDate={date_from}
        minDate={date_from}
        maxDetail={"month"}
        maxDate={date_to}
        onClickDay={on_click}
        value={date}
      />
    </Popup>) : null;*/
  const small_layout = width <= DEVICE_WIDTH.medium;
  const container_style = {
    display: "flex",
    width: "100%",
    paddingRight: small_layout ? "0" : "10rem",
    flexWrap: small_layout ? "wrap" : "nowrap",
  }
  const item_style = {
    flex: small_layout ? "1 1 100%" : "1 1 50%",
  }
  const month_container = {
    display: is_monthly ? "": "none",
  };
  const cadence_container = {
    padding: small_layout ? "0" : "0 1rem",
  }
  if (small_layout) {
    month_container.flex = "1";
    cadence_container.flex = "1";
  }
  return (
    <div style={container_style}>
      <div style={item_style}>
        <div style={{display: "flex"}}>
          <div style={cadence_container}>
            <div>{contribute_cadence.name.label}</div>
            { contribute_cadence.renderMenu(component) }
          </div>
          { /* <div style={month_container}>
            <div>Day of month</div>
            <Action onClick={show_cal_cb}>
              <span>{dom}</span>
            </Action>
            { popup }
          </div> */ }
        </div>
      </div>
      <div style={item_style}>
        <div>{contribute_amt.name.label}</div>
        { contribute_amt.renderInput(component, contrib_style) }
      </div>
    </div>
  )
};

export { render_recurring_payment, render_recurring_payment_2 };
